import { useSelector } from "react-redux";
import { useGetAvailableReportsDataQuery } from "../../../store/queries/MainReport";
import { getPrintData } from "../api";
import moment from "moment";
import { toast } from "react-toastify";
import { useState } from "react";

const useReportPrint = ({ data }) => {
  const [loadingIndex, setLoadingIndex] = useState(null);

  const { selectedItem } = useSelector((state) => state.mainReport);
  const { data: availableReports, isFetching } =
    useGetAvailableReportsDataQuery({
      receipt_id: selectedItem,
    });
  let gliNumber = data?.find((item) => item?._id === selectedItem)?.gli_number;
  const handlePrintClick = (index, reportName) => {
    setLoadingIndex(index);
    let count = index + 1;
    getPrintData(selectedItem, count).then((response) => {
      if (response?.status === 200) {
        setLoadingIndex(null);
        if (response?.data?.message === "Additional document") {
          const url = response?.data?.data?.url;
          const link = document.createElement("a");
          link.href = url;
          link.download = url.split("/").pop();
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          let dataType = response?.data?.type;
          let binaryData = [];
          binaryData.push(response?.data);
          let downloadLink = document.createElement("a");
          downloadLink.href = window.URL.createObjectURL(
            new Blob(binaryData, { type: dataType }),
          );
          downloadLink.setAttribute(
            "download",
            `${gliNumber}_${reportName}_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.xlsx`,
          );
          document.body.appendChild(downloadLink);
          downloadLink.click();
        }
      } else {
        setLoadingIndex(null);
        toast.error("Something went wrong");
      }
    });
  };
  return {
    loadingIndex,
    availableReports,
    handlePrintClick,
    isFetching,
  };
};

export default useReportPrint;
